import TelegramThumb from '../../TelegramThumb';
import { AutoDeleteField, MediaUploadLabel } from '../../MediaFields';

export default function VideoNode({ id, data, botId }) {
    const media = data?.media || {};

    if (data?.uploadingMedia) return (
        <div className="mt-2">
            <div className="border-2 border-dashed rounded-lg p-3 border-white/[0.06] flex flex-col items-center gap-1">
                <i className="fas fa-spinner fa-spin text-white/40 text-lg" />
                <p className="text-[10px] text-white/50">Enviando...</p>
                <p className="text-[9px] text-white/30">aguarde</p>
            </div>
        </div>
    );

    return (
        <div className="mt-2 space-y-2">
            {media.video ? (
                <>
                    <label className="relative border-2 border-dashed rounded-lg p-3 transition-colors cursor-pointer border-white/[0.06] hover:border-white/[0.08] block">
                        <input accept="video/*" className="hidden" type="file"
                            onChange={(e) => { const f = e.target.files?.[0]; if (f) data?.onUploadMedia?.(id, 'video', f); e.target.value = ''; }} />
                        {/* <button
                            type="button"
                            className="absolute top-1 right-1 text-red-400 hover:text-red-300 z-10 text-[10px]"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); data?.onDeleteMedia?.(id, 'video'); }}
                        >
                            <i className="fas fa-trash" />
                        </button> */}
                        <div className="flex items-center justify-center min-h-[6rem]">
                            {media.thumbnail
                                ? <TelegramThumb fileId={media.thumbnail} botId={botId}
                                    imgClassName="w-full max-h-24 object-contain rounded-lg" />
                                : <i className="fas fa-play-circle text-red-400 text-3xl opacity-80" />
                            }
                        </div>
                        <p className="text-[10px] text-white/50 truncate max-w-full mt-1">
                            {media.fileName || media.video}
                        </p>
                        <p className="text-[9px] text-white/30">Clique para trocar</p>
                    </label>
                    <input type="text" className="input3 w-full" placeholder="Legenda (opcional)"
                        value={media.caption || ''}
                        onChange={(e) => data?.onChangeMedia?.(id, { caption: e.target.value })} />
                    <label className="flex items-center gap-2 text-[10px] text-gray-300">
                        <input type="checkbox" className="h-3 w-3 rounded border-white/20 bg-white/10"
                            checked={Boolean(media.has_spoiler)}
                            onChange={(e) => data?.onChangeMedia?.(id, { has_spoiler: e.target.checked })} />
                        <span>Spoiler</span>
                    </label>
                    <AutoDeleteField
                        value={media.auto_delete_seconds}
                        onToggle={(checked) => data?.onChangeMedia?.(id, { auto_delete_seconds: checked ? 5 : null })}
                        onChangeSeconds={(v) => data?.onChangeMedia?.(id, { auto_delete_seconds: v })} />
                </>
            ) : (
                <MediaUploadLabel accept="video/*"
                    onUpload={(f) => data?.onUploadMedia?.(id, 'video', f)} />
            )}
        </div>
    );
}
